import React, { useEffect } from 'react';
import './Terms.css'


function Construction(props) {
    window.scrollTo(0, 0);
    useEffect(() => {
        if (!props.showSearch) {
            props.setShowSearch(true)
        }
    }, [])
    return (
        <div className="Terms commonContainer" >
            <div className="AboutUs-container" style={{ backgroundColor: "white" }}>
                <div style={{ marginLeft: "auto", marginRight: "auto"}}>
                    <p style={{ textAlign: "center" }}>
                    This page is under construction.
                </p>
                </div>
            </div>
        </div>
    );
}
export default Construction;